import * as React from 'react';
export const documentSvg = React.forwardRef(function documentSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M11 2.5v7A2.5 2.5 0 0 1 8.5 12h-5A2.5 2.5 0 0 1 1 9.5V4.328a2 2 0 0 1 .586-1.414L3.914.586A2 2 0 0 1 5.328 0H8.5A2.5 2.5 0 0 1 11 2.5Zm-1.4 0v7a1.1 1.1 0 0 1-1.1 1.1h-5a1.1 1.1 0 0 1-1.1-1.1V6.15h3.1A1.65 1.65 0 0 0 7.15 4.5V1.4H8.5a1.1 1.1 0 0 1 1.1 1.1ZM5.85 1.4h-.522a.6.6 0 0 0-.424.176L2.576 3.904a.6.6 0 0 0-.176.424v.522h3.1a.35.35 0 0 0 .35-.35V1.4Z',
    }),
  );
});
documentSvg.defaultProps = {
  width: '12',
  height: '12',
  viewBox: '0 0 12 12',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var document = {
  category: 'icon',
  colorable: true,
  name: 'document',
  svg: documentSvg,
};
